import { useState } from "react";
import { Button } from "../components/Button/Button";
import styled from "styled-components";
import { ApiRequest } from "../api/Api";
import { useMessageStore } from "../store/MessageStore";

export const Sync = () => {
	const [sync, setSync] = useState(false);
	const [syncState, setSyncState] = useState("");
	const addMessage = useMessageStore((state) => state.addMessage);

	const SyncHandler = async (
		network: "tron" | "ethereum",
		type: "balance" | "transactions"
	) => {
		if (sync) {
			return;
		}

		addMessage("success", `Начало обновления`);

		setSync(true);
		setSyncState("Синхронизация данных кошельков");
		const result = await ApiRequest(`/sync`, { type, network });
		if (result?.status === "error") {
			setSyncState("Синхронизация завершена с ошибкой");
		}
		if (result?.status === "success") {
			setSyncState("Синхронизация завершена успешно");
		}
		setSync(false);
	};

	return (
		<StyledComponent>
			<div className="title">Синхронизация данных кошельков</div>
			<div className="subtitle">Баланс</div>
			<div className="network">
				<Button onClick={() => SyncHandler("tron", "balance")}>
					Tron
				</Button>
				<Button onClick={() => SyncHandler("ethereum", "balance")}>
					Ethereum
				</Button>
			</div>
			<div className="subtitle">Транзакции</div>
			<div className="network">
				<Button onClick={() => SyncHandler("tron", "transactions")}>
					Tron
				</Button>
				<Button onClick={() => SyncHandler("ethereum", "transactions")}>
					Ethereum
				</Button>
			</div>
			<div className="syncResult">{syncState}</div>
		</StyledComponent>
	);
};

const StyledComponent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	& .network {
		display: flex;
		justify-content: center;
		gap: 1rem;

		& button {
			flex-grow: 1;

			&.selected {
				background-color: rgba(255, 255, 255, 0.1);
			}
		}
	}

	& .title {
		font-size: 2rem;
	}

	& .syncResult,
	.title {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 1rem;
	}
`;
